import { useTranslation } from 'react-i18next';

export const useHomeComingSoon = () => {
  const { t } = useTranslation();

  const forbiddenText: string = t('_ACCESSES_WITH_FORBIDDEN_ENTRY_PROJECT_TEXT');

  return { forbiddenText };
};
